import { Injectable } from '@angular/core';
import { SpecialHours } from '@generated/tcea/models';
import { WeekHours, Time } from '@generated/tcea/models';
import { SpecialHoursUIItem } from '@interfaces/brand/1.0';
import { DateService } from '@services/utilities/1.0/date.service';
import { DeepCloneService } from '@services/utilities/1.0/deep-clone.service';

const TIME_24HR_REGEX = /^(2[0-3]|[01]?[0-9]):([0-5][0-9])$/;

@Injectable({
  providedIn: 'root',
})
export class HoursUtilitiesService {
  constructor(private dateService: DateService) {}

  private static toPlainDate(value: string | Date): string {
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
      return value;
    }

    const date = value instanceof Date ? value : new Date(value);
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, '0');
    const day = `${date.getDate()}`.padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  static convertHoursToForm(storeHours: WeekHours | PrepTimeHours) {
    const mergedRows: any = {};

    if (storeHours) {
      for (const day in storeHours) {
        if (storeHours.hasOwnProperty(day)) {
          const hours = storeHours[day];

          for (const hour of hours) {
            const key = `${hour.startTime}-${hour.endTime}-${hour.prepTime}`;
            if (!mergedRows[key]) {
              mergedRows[key] = {
                days: [day],
                startTime: hour.startTime,
                endTime: hour.endTime,
                prepTime: hour.prepTime,
              };
            } else {
              mergedRows[key].days.push(day);
            }
          }
        }
      }
    }

    const formArray = Object.values(mergedRows);

    return formArray;
  }

  static convertFormToStoreHours(formHours): WeekHours | PrepTimeHours {
    const storeHours: WeekHours = {} as WeekHours;
    if (formHours) {
      for (const hour of formHours) {
        for (const day of hour.days) {
          if (!storeHours[day]) {
            storeHours[day] = [];
          }
          const timeValue: any = { startTime: hour.startTime, endTime: hour.endTime };
          if (hour.prepTime) {
            timeValue.prepTime = hour.prepTime;
          }
          storeHours[day].push(timeValue);
        }
      }
    }
    return storeHours;
  }

  static get24HourTimeRegex(): RegExp {
    return TIME_24HR_REGEX;
  }

  static convertSpecialHoursUIToSpecialHours(specialHours: SpecialHoursUIItem[]): SpecialHours[] {
    const result: SpecialHours[] = [];
    if (specialHours) {
      for (const hour of specialHours) {
        const item: SpecialHoursUIItem = DeepCloneService.clone(hour);
        if (item.rule && item.rule.value) {
          item.rule.value = this.toPlainDate(item.rule.value);
        }
        if (!item.isOpen) {
          item.operatingHours = [];
        }
        delete item.isOpen;
        result.push(item);
      }
    }
    return result;
  }
}

interface PrepTimeHours extends WeekHours {
  prepTime?: number;
}
